import { convertDatesToISO, getHeaders } from '@/config/aux'
import { Sensor } from '../models/sensor'
import { SensorStateType } from './state'
import axios from 'axios'

export interface SensorActionsType {
  getSensors(): Promise<void>
  getSensorByField(field: string): Promise<void>
  postSensor(sensor: Sensor): Promise<void>
  putSensor(sensor: Sensor): Promise<void>
  deleteSensor(id: string): Promise<void>
}

export const SensorActions = {
  async getSensors(this: SensorStateType) {
    try {
      this.sensors = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensors`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensor: Sensor) => {
            this.sensors.push(sensor)
          })
        }
      })
    } catch (error) {
      console.error('Error getting Sensors', error)
    }
  },
  async getSensorByField(this: SensorStateType, field: string) {
    try {
      this.sensor = null
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensors/field/${field}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          this.sensor = response.data
        }
      })
    } catch (error) {
      console.error('Error getting Sensor by field', error)
    }
  },
  async postSensor(this: SensorStateType, sensor: Sensor) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensors`
      const data = convertDatesToISO(sensor.toPlainObject())

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 201) {
          // this.sensors.push(sensor)
        }
      })
    } catch (error) {
      console.error('Error posting Sensor', error)
    }
  },
  async putSensor(this: SensorStateType, sensor: Sensor) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensors`
      const data = convertDatesToISO(sensor.toPlainObject())

      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            //this.sensors = this.sensors.map(s => (s.id === sensor.id ? sensor : s))
          }
        })
    } catch (error) {
      console.error('Error updating Sensor', error)
    }
  },
  async deleteSensor(this: SensorStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensors/${id}`
      await axios.delete(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          //this.sensors = this.sensors.filter(s => s.id !== id)
        }
      })
    } catch (error) {
      console.error('Error deleting Sensor', error)
    }
  },
}
